/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCollateral = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13.414 2 20 8.586V11h-2v-1h-6V4l-8 .008v16h6v2H2V2.01zM17 12a3 3 0 0 1 3 3v1h2v6H12v-6h2v-1a3 3 0 0 1 3-3zm3 6h-6v2h6zm-10-3v2H6v-2zm7-1a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1zm-5-3v2H6v-2zm2-5.586V8h2.586z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCollateral as Collateral };
